webpackJsonp([17],{

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


var toggleInquiryKind = function toggleInquiryKind() {
  var trouble = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-inquiryTrouble');
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-inquiryKind').val() === '1') {
    trouble.show();
  } else {
    trouble.hide();
  }
};

var togglePrivacy = function togglePrivacy() {
  var button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-button');
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-privacy').prop('checked')) {
    button.css('opacity', '1').removeAttr('disabled');
  } else {
    button.css('opacity', '0.3').attr('disabled', 'disabled');
  }
};

var changeInquiryKind = function changeInquiryKind() {
  toggleInquiryKind();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-inquiryKind').on('change', function () {
    toggleInquiryKind();
  });
};

var changePrivacy = function changePrivacy() {
  togglePrivacy();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-privacy').on('click', function () {
    togglePrivacy();
  });
};

var start = function start() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-inquiryTrouble').hide();
  changeInquiryKind();
  changePrivacy();
};

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  start();
});

/***/ })

},[126]);


// WEBPACK FOOTER //
// assets/js/inquiry.js